import { useEffect } from "react";
import eventSub, { EventName } from "@/lib/EventSub.ts";
import { getToken } from "@/lib/auth";
import { dispatchLogout } from "@/lib/logoutRegistry";

/** 全局唯一 NoAuth 订阅：401 时清理登录态（具体逻辑由 useLogin 注册的 logout 执行） */
export function NoAuthSubscriber() {
  useEffect(() => {
    const handleNoAuth = () => {
      if (getToken()) {
        dispatchLogout({ silent: true });
      }
    };
    eventSub.subscribe(EventName.NoAuth, handleNoAuth);
    return () => eventSub.unsubscribe(EventName.NoAuth, handleNoAuth);
  }, []);
  return null;
}
